var _classCallCheck = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var Web3 = require('web3');

var RelayClient = require('./RelayClient');

var RelayProvider =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * create a proxy provider, to relay transaction
   * @param origProvider - the underlying web3 provider
   * @param relayOptions:
   *      disableRelay - true to bypass the relay, and call directly the origProvider.
   *      skipSenders - hash of "from" addresses that should bypass the relay ( e.g. skipSenders={myDirectAddress:true} )
   *      other options of RelayClient..
   */
  function RelayProvider(origProvider, relayOptions) {
    _classCallCheck(this, RelayProvider);

    relayOptions = relayOptions || {};
    relayOptions.isRelayEnabled = true;
    this.relayOptions = relayOptions;

    if (origProvider.origProvider) {
      //we're 2nd-level wrapper.. disable previous one.
      console.log("wrapping RelayProvider with another.. skipping previous one.");
      origProvider = origProvider.origProvider;
    }

    this.origProvider = origProvider;
    this.origProviderSend = (this.origProvider['sendAsync'] || this.origProvider['send']).bind(this.origProvider);
    this.relayClient = new RelayClient(new Web3(origProvider), relayOptions);
  }

  _createClass(RelayProvider, [{
    key: "enable",
    value: function enable(isRelayEnabled) {
      this.relayOptions.isRelayEnabled = isRelayEnabled;
    }
  }, {
    key: "send",
    value: function send(payload, callback) {
      var _this = this;

      if (!this.skipRelay(payload)) {
        if (payload.method == 'eth_sendTransaction') {
          if (this.relayOptions.verbose) console.log("calling sendAsync" + JSON.stringify(payload));
          this.relayClient.runRelay(payload, callback);
          return;
        } else if (payload.method == 'eth_getTransactionReceipt') {
          if (this.relayOptions.verbose) console.log("calling sendAsync" + JSON.stringify(payload));
          this.origProviderSend(payload, function (e, r) {
            if (e) callback(e);else {
              _this.relayClient.fixTransactionReceiptResp(r.result);

              callback(null, r);
            }
          });
          return;
        }
      }

      this.origProviderSend(payload, function (error, result) {
        callback(error, result);
      });
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(payload, callback) {
      return this.send(payload, callback);
    } //hook method: skip relay if the "from" address appears in optins.skipSenders

  }, {
    key: "skipRelay",
    value: function skipRelay(payload) {
      var ret = false;

      if (payload.params && payload.params[0]) {
        var useGSN = payload.params[0].useGSN;
        if (typeof useGSN === 'undefined') useGSN = this.relayOptions.useGSN;
        if (typeof useGSN === 'function') useGSN = useGSN(payload);

        if (typeof useGSN !== 'undefined' && !useGSN) {
          ret = true;
        }
      }

      if (!ret) {
        ret = !this.relayOptions.isRelayEnabled || this.relayOptions.skipSenders && this.relayOptions.skipSenders[payload.params.from];
      }

      return ret;
    }
  }]);

  return RelayProvider;
}();

module.exports = RelayProvider;